import React from 'react'

type ChipVariant = 'success' | 'error' | 'warning' | 'info' | 'default'

type Props = {
  label: string;
  variant?: ChipVariant;
  size?: 'sm' | 'md' | 'lg';
}

const variantStyles = {
  success: 'bg-green-50 text-green-700 border-green-200',
  error: 'bg-red-50 text-red-700 border-red-200',
  warning: 'bg-yellow-50 text-yellow-700 border-yellow-200',
  info: 'bg-green-50 text-blue-700 border-blue-200',
  default: 'bg-gray-50 text-gray-700 border-gray-200'
}

const sizeStyles = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-3 py-1 text-sm',
  lg: 'px-4 py-1.5 text-base'
}

const Chip: React.FC<Props> = ({ label, variant = 'default', size = 'sm' }) => {
  return (
    <span className={`
      inline-flex items-center justify-center
      font-medium rounded-lg border
      ${variantStyles[variant]}
      ${sizeStyles[size]}
    `}>
      {label}
    </span>
  )
}

export default Chip